/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerSessionReminderParams } from './lecturerSessionReminderParams';

/**
 * Request model for lecturer session reminder job
 */
export interface RunLecturerSessionReminderJobRequest {
  type: 'lecturer_session_reminder';
  params: LecturerSessionReminderParams;
  allowOverlappingJobs?: boolean;
}
